export default function defaultState() {
  return {
    recordsType: [],
    isLoading: true,
  }
}
